var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ compact: _vm.isCompact },attrs:{"id":"home"}},[_c('Navbar',{attrs:{"is-compact":_vm.isCompact}}),_c('div',{staticClass:"container-fluid"},[_c('main',{staticClass:"main-content"},[_c('router-view')],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }